import React from 'react';
import proptypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { Drawer, IconButton } from '@one-thd/sui-atomic-components';
import { Email } from '@one-thd/sui-icons';
import { EmailListDrawerBody } from '../ListSettings/drawerBodies/EmailListDrawerBody';
import ShareAction from './ShareAction';

const { string, bool } = proptypes;

export const EmailList = ({ listId, iconSize, shareIcon }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="sui-flex sui-justify-center" data-component="email-list">
      {shareIcon ? (
        <ShareAction onClick={handleOpen} iconSize={iconSize} />
      ) : (
        <IconButton
          iconSize={iconSize}
          icon={Email}
          alt="Email"
          aria-label="Email"
          onClick={handleOpen}
        />
      )}
      <Drawer open={open} onClose={handleClose}>
        <EmailListDrawerBody
          listId={listId}
          onClose={handleClose}
          menuName="Email List"
          hideBackButton
        />
      </Drawer>
    </div>
  );
};

EmailList.propTypes = {
  listId: string,
  iconSize: string,
  shareIcon: bool
};

EmailList.defaultProps = {
  listId: null,
  iconSize: 'small',
  shareIcon: false
};

EmailList.displayName = 'EmailList';

EmailList.dataModel = extend(
  EmailListDrawerBody
);
